import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import { Dropdown } from '@components/Form/Autocomplete'
import Button from '@components/Button'
import { projectApi } from '@atheneum/api'

class ProjectCategoryForm extends Component {

    static propTypes = {
      staticData: PropTypes.object,
      modalStore: PropTypes.object,
      projectStore: PropTypes.object,
      growlStore: PropTypes.object,
      actionAfterSubmit: PropTypes.func
    }

    constructor(props) {
      super(props)
      this.state = {
        projectCategoryId: 1
      }
    }

    handleSubmit = (value, actions) => {
      actions.setSubmitting(true)
      const { modalStore, growlStore, actionAfterSubmit, projectStore } = this.props
      const { project } = projectStore
      
      projectApi.updateCategory(project.id, value.projectCategoryId).then(async res => {
        modalStore.close()
        growlStore.showSuccess('Project updated successfully')
        if(actionAfterSubmit){
          projectStore.setProjectCategory(value.projectCategoryId)
          await actionAfterSubmit()
        }
        return res
      })
        .catch(err => {
          growlStore.showError(err.message)
        })
      actions.setSubmitting(false)
    }
    
    render(){
      const { staticData, modalStore } = this.props
      return (
        <Formik
          initialValues={{ projectCategoryId: this.state.projectCategoryId }}
          onSubmit={this.handleSubmit}
          render={form => (
          
          <div className='expert-form'>
            <h1 className='expert-form__title'>
              {'Select project category'}
            </h1>
              <Form onSubmit={form.handleSubmit}>
                <div className='expert-form__section'>
                <Field
                  name='projectCategoryId'
                  label='Project category'
                  itemToString={i => i ? i.name : ''}
                  component={Dropdown}
                  options={staticData.projectCategories.sort((a, b) => a.id - b.id)}
                />
                </div>
                <div className='expert-form__section'>
                  <Button
                    primary
                    submit
                    onClick={this.onSubmit}
                    disabled={form.isSubmitting}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={modalStore.close}
                    disabled={form.isSubmitting}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
          </div>
            
            )}
        />
      )
    }
}

ProjectCategoryForm.defaultProps = {
  hideButtons: true,
  showCloseIcon: true,
  shouldCloseOnOverlayClick: false
}

export default withRouter(
  inject(
    'staticData',
    'modalStore',
    'projectStore',
    'growlStore'
  )(observer(ProjectCategoryForm)))